module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "textcenter"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v("ALSO BY JEANETTE WINTERSON")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("Oranges Are Not the Only Fruit"), _c('br'), _vm._v("Sexing the Cherry"), _c('br'), _vm._v("Written on the Body"), _c('br'), _vm._v("Art and Lies"), _c('br'), _vm._v("Art Objects"), _c('br'), _vm._v("Gut Symmetries")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae9685bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm02_preface.vue
// module id = 60
// module chunks = 0